'use strict';

wbApp.directive('wbErrorAlert', ['errorTypeTranslateSvc',
    function (errorTypeTranslateSvc) {
        return {
            restrict: 'A',
            require: 'ngModel',
            priority: 1,
            scope: {
                serverError: '=ngModel',
                formErrors: '=formErrors'
            },
            replace: true,
            template:
                "<div class='bs-callout bs-callout-danger wb-server-alert' ng-show='showErrors()'>" +
                    "<h4>{{'TXT_TITLE_FIX_ERRORS' | translate}}</h4>" +
                    "<ul ng-show='!!serverError.data.title' class='list-unstyled'><li>{{serverError.data.title}}</li></ul>" +                    
                    "<ul class='list-unstyled' ng-show='serverError'>" +
                        "<li ng-repeat='error in serverError.errors'>{{error.message}}</li>" +
                    "</ul>" +
                    "<ul class='list-unstyled' ng-show='formErrors'>" +
                        "<li ng-repeat='(key, errors) in formErrors track by $index'>" +
                            "<ul>" +
                                "<li ng-repeat='e in errors'>{{ e.$name }} : <strong>{{ translateError(key) }}</strong>.</li>" +
                            "</ul>" +
                        "</li>" +
                    "</ul>" +
                "</div>",
            link: function (scope, elm, attrs, controller) {
                scope.translateError = function (error) {
                    return errorTypeTranslateSvc.translate(error, null, scope);
                };

                scope.showErrors = function() {
                    var result = scope.serverError || (scope.formErrors && Object.keys(scope.formErrors).length > 0);
                    return result;
                }

            }
        }
    }]);
